import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneButton } from '@yy/one-ui'
import noFoundPage from '@/static/svg/noFoundPage.svg'
import Logo from '@/static/imgs/logo.svg'
import styles from './index.module.less'

export const ErrorPage: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.errorPage}>
      <div className={styles.header}>
        <img className={styles.logo} src={Logo} alt="oneWarehouse" />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>{t('common.error.noFound')}</p>
        <p className={styles.desc}>{t('common.error.refreshTips')}</p>
        <img className={styles.noFoundPage} src={noFoundPage} alt="oneWarehouse" />

        <div className={styles.btnBox}>
          <OneButton
            type="primary"
            onClick={() => {
              window.location.reload()
            }}
          >
            {t('common.refresh')}
          </OneButton>
        </div>
      </div>
    </div>
  )
}
